import { render, staticRenderFns } from "./ScoringComponent.vue?vue&type=template&id=1db07b6f&scoped=true"
import script from "./ScoringComponent.vue?vue&type=script&lang=js"
export * from "./ScoringComponent.vue?vue&type=script&lang=js"
import style0 from "./ScoringComponent.vue?vue&type=style&index=0&id=1db07b6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db07b6f",
  null
  
)

export default component.exports